import React from '../helpers/react';
import {postBookmark, toggleBookmark} from '../actions/bookmark.action.js';
import {connect} from '../helpers/composeReducer.js';
import classList from 'ereader-core/dist/classList';
import {getHookClass} from '../helpers/cssHooks.js';

import {trigger} from '../helpers/events.js';

export const BookmarkTab =  React.createClass({

  getInitialState: function(){
    return {};
  },

  clickBookmark : function() {
    this.postBookmark();
    trigger('bookmarkClicked', {
        id: this.props.problem.problemId,
        bookmarked: !this.props.bookmark_tab.isBookmarked
    });
    document.getElementById('notification').removeAttribute('aria-hidden');
    if (!this.props.bookmark_tab.isBookmarked) {
        document.getElementById('notification').innerHTML = this.props.getDef('bookmark-tab.bookmark-solution-action');
    }
    else {
        document.getElementById('notification').innerHTML = this.props.getDef('bookmark-tab.unbookmark-solution-action');
    }
  },

  postBookmark : function() {
    let count = 0;
    if(this.props.bookmark_tab.count) {
      count = this.props.bookmark_tab.isBookmarked ? --this.props.bookmark_tab.count : ++this.props.bookmark_tab.count;
    }

    this.props.postBookmark({
      isBookmarked: this.props.bookmark_tab.isBookmarked,
      id: this.props.problem.problemId,
      chapterId: this.props.problem.chapter.chapterId,
      isbn13: this.props.isbn13,
      count: count
    });
  },
  keyDownBookmarkTab: function(e){
      e.preventDefault();
      // # Accessibility -- let element respond to Tab
      if (e.keyCode === 9) {
          document.getElementById('show-all-steps').focus();
      }
      // # Accessibility -- let element respond to ENTER and SPACE
      if(e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          e.currentTarget.click();
          const rate_solution = document.getElementById('rate-the-solution');
          if(rate_solution) {
              rate_solution.focus();
          }
          else {
              return false;
          }
      }
      // # Accessibility -- let element respond to Shift + Tab
      if(e.shiftKey && e.keyCode === 9) {
          if(this.props.show_mobile) {
              document.getElementById('mobile-tab').focus();
          }
          else {
              document.getElementById('toc-button').focus();
          }
      }
  },

  render : function(){
    if (!this.props.show_bookmark) {
      return null;
    }

    let bookmarkBtnClass = classList('button','button-icon','bookmark-btn');

    bookmarkBtnClass.push(this.props.bookmark_tab.isBookmarked ? 'bookmarked' : 'bookmark');

    let bookmarkCount = this.props.bookmark_tab.count;

    if(bookmarkCount) {
      bookmarkBtnClass.push('bookmark-count');
    }

    let mainClass = classList('bookmark-tab', getHookClass('BookmarkTab'));

    if(!this.props.show_fullscreen) {
      mainClass.push('no-fullscreen');
    }

    let bookmarkMsg   = '';

    if(bookmarkCount) {
      bookmarkMsg = bookmarkCount > 1 ? (bookmarkCount >= 1000 ? this.props.getDef('bookmark-tab.bookmark-count-plural-display',
          {count: Math.floor(bookmarkCount / 100)/10}) : this.props.getDef('bookmark-tab.bookmark-count-plural',
          {count: bookmarkCount})) : this.props.getDef('bookmark-tab.bookmark-count-single');
    }
    else {
      bookmarkMsg = this.props.bookmark_tab.isBookmarked ? this.props.getDef('bookmark-tab.bookmarked') : this.props.getDef('bookmark-tab.not-bookmarked');
    }

    return (
      <div key="bookmark-container" className={mainClass}>
          <div className="visually-hidden" id="bookmark-description">{this.props.bookmark_tab.isBookmarked ? this.props.getDef('bookmark-tab.unbookmark-solution-description') : this.props.getDef('bookmark-tab.bookmark-solution-description')}</div>
        <button tabIndex="0" id="bookmark-tab" onKeyDown={(e)=>this.keyDownBookmarkTab(e)} aria-describedby="bookmark-description" key="bookmark-button" role="button" aria-pressed={this.props.bookmark_tab.isBookmarked} className={bookmarkBtnClass} onClick={this.clickBookmark} aria-label={this.props.bookmark_tab.count < 1 ? this.props.getDef('bookmark-tab.bookmark-label-no-bookmarks') : this.props.getDef('bookmark-tab.bookmark-label', {book : bookmarkMsg})}>
            {bookmarkMsg}
        </button>
      </div>
    );
  }
});

export function mapStateToProps(state){

	return {
      problem : state.problem,
      show_bookmark: state.options.show_bookmark,
      show_fullscreen: state.options.show_fullscreen,
      show_mobile : state.options.show_mobile,
      getDef : state.helpers.getDef,
      isbn13 : state.model.isbn13,
      bookmark_tab : state.bookmark_tab
	};
}

export default connect(mapStateToProps,{
    postBookmark
})(BookmarkTab);



// WEBPACK FOOTER //
// ./src/components/BookmarkTab.js